var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSla01 = function SvgSla01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sla-01_svg2__a",
    x1: -13.67,
    x2: 155.04,
    y1: 159.79,
    y2: -8.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__b",
    x1: 55.52,
    x2: 95.33,
    y1: 36.43,
    y2: -3.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__c",
    x1: -30.79,
    x2: 137.92,
    y1: 142.67,
    y2: -26.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__d",
    x1: -44.04,
    x2: 124.67,
    y1: 129.42,
    y2: -39.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__e",
    x1: -30.15,
    x2: 138.56,
    y1: 143.32,
    y2: -25.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__f",
    x1: -6.3,
    x2: 162.41,
    y1: 167.17,
    y2: -1.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__g",
    x1: -8.31,
    x2: 160.4,
    y1: 165.16,
    y2: -3.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__h",
    x1: -13.39,
    x2: 155.31,
    y1: 160.07,
    y2: -8.64
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__i",
    x1: 10.45,
    x2: 179.16,
    y1: 183.92,
    y2: 15.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__j",
    x1: 8.44,
    x2: 177.15,
    y1: 181.91,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__k",
    x1: 3.2,
    x2: 171.91,
    y1: 176.67,
    y2: 7.96
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__l",
    x1: 25.04,
    x2: 193.75,
    y1: 198.51,
    y2: 29.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__m",
    x1: 19.8,
    x2: 188.51,
    y1: 193.26,
    y2: 24.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__n",
    x1: 41.64,
    x2: 210.35,
    y1: 215.11,
    y2: 46.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__o",
    x1: 9.25,
    x2: 177.96,
    y1: 182.71,
    y2: 14.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla-01_svg2__a",
    id: "sla-01_svg2__p",
    x1: 64.89,
    x2: 233.6,
    y1: 238.35,
    y2: 69.64
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m101.78 45.9 1.64-4.3h11.16l1.62 4.29c.44 1.17 1.56 1.9 2.74 1.9a2.938 2.938 0 0 0 2.74-3.97l-9.38-24.84s-.02-.05-.03-.08c-.54-1.32-1.81-2.17-3.24-2.17s-2.7.86-3.24 2.18c0 .02-.02.04-.03.07L96.3 43.82c-.58 1.51.18 3.2 1.7 3.78 1.51.58 3.2-.18 3.78-1.7m7.23-19.01h.01l3.34 8.86h-6.72z",
    style: {
      fill: "url(#sla-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.42 16.52h.01z",
    style: {
      fill: "url(#sla-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 19.45v25.18a2.93 2.93 0 0 0 2.44 2.89c.21.04.38.06 3.16.06 1.35 0 3.3 0 6.17-.02 1.62 0 2.92-1.33 2.91-2.95 0-1.61-1.32-2.91-2.93-2.91h-.02c-2.03 0-4.21.02-5.88.02V19.45a2.92 2.92 0 1 0-5.84 0Z",
    style: {
      fill: "url(#sla-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.64 40.63a2.934 2.934 0 0 0-4.14-.07 2.934 2.934 0 0 0-.07 4.14c2.65 2.74 6.59 4.34 10.6 4.34h.5c5.2-.17 9.46-3.63 10.12-8.21.5-3.44-1.21-7.87-7.52-9.96-3.17-1.05-6.12-2.21-6.99-2.56-.82-.59-.82-1.47-.78-1.84.05-.49.36-1.69 2.08-2.27 3.63-1.23 7.1 1.34 7.19 1.41A2.927 2.927 0 0 0 60.24 21c-.24-.19-5.97-4.6-12.67-2.34-3.36 1.13-5.67 3.89-6.04 7.18-.34 3.09 1.09 5.99 3.73 7.59.13.08.27.15.41.21.15.06 3.66 1.49 7.61 2.8 1.17.39 3.86 1.51 3.56 3.56-.22 1.51-1.97 3.11-4.52 3.2l.02-.02c-2.56.09-5.07-.87-6.7-2.55",
    style: {
      fill: "url(#sla-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.63 62.35h-.01v12.96c0 2.89 2.35 5.24 5.24 5.24h12.95c1.4 0 2.72-.55 3.71-1.54s1.54-2.31 1.54-3.71V62.35c0-2.89-2.35-5.24-5.24-5.24H37.87c-2.89 0-5.24 2.35-5.24 5.24m5.85.62H50.2v11.72H38.48z",
    style: {
      fill: "url(#sla-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.81 62.62c0 1.62 1.31 2.93 2.93 2.93h59c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93h-59c-1.62 0-2.93 1.31-2.93 2.93",
    style: {
      fill: "url(#sla-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74 77.52h27.03c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93H68.74c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93",
    style: {
      fill: "url(#sla-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.36 95.55h-.01c0-2.88-2.35-5.23-5.24-5.23H38.16c-2.89 0-5.24 2.35-5.24 5.24v12.95c0 2.89 2.35 5.24 5.24 5.24h12.95c1.4 0 2.72-.55 3.71-1.54s1.54-2.31 1.54-3.71zm-5.87 12.34H38.77V96.17h11.72z",
    style: {
      fill: "url(#sla-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.98 95.83c0-1.62-1.31-2.93-2.93-2.93h-59c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h59c1.62 0 2.93-1.31 2.93-2.93",
    style: {
      fill: "url(#sla-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.04 104.86c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h27.03c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93z",
    style: {
      fill: "url(#sla-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.36 128.75h-.01c0-2.88-2.35-5.23-5.24-5.23H38.16c-2.89 0-5.24 2.35-5.24 5.24v12.95c0 2.89 2.35 5.24 5.24 5.24h12.95c1.4 0 2.72-.55 3.71-1.54s1.54-2.31 1.54-3.71zm-5.87 12.35H38.77v-11.72h11.72z",
    style: {
      fill: "url(#sla-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.04 143.93h27.03c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93H69.04c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93",
    style: {
      fill: "url(#sla-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.11 156.7-12.95.01c-2.89 0-5.24 2.35-5.24 5.24v12.95c0 2.89 2.35 5.24 5.24 5.24h12.95c1.4 0 2.72-.55 3.71-1.54s1.54-2.31 1.54-3.71v-12.95c0-2.89-2.35-5.24-5.24-5.24Zm-.62 17.59H38.77v-11.72h11.72z",
    style: {
      fill: "url(#sla-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07 177.12c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93H69.04c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93z",
    style: {
      fill: "url(#sla-01_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.95 143.06v-.02a2.94 2.94 0 0 0-3.93-1.35 2.926 2.926 0 0 0-1.35 3.92c2.24 4.61 3.38 9.58 3.38 14.75 0 18.63-15.15 33.78-33.78 33.78s-33.79-15.15-33.79-33.78 15.16-33.78 33.79-33.78c8.48 0 16.59 3.16 22.84 8.89a2.936 2.936 0 0 0 4.14-.18 2.927 2.927 0 0 0-.18-4.14 39.5 39.5 0 0 0-23.87-10.31V44.75h20.02c3.34 0 6.05-2.72 6.05-6.05V15.97c0-8.81-7.16-15.97-15.96-15.97h-135c-6.74 0-12.23 5.48-12.23 12.23v39.42c0 1.62 1.31 2.93 2.93 2.93s2.93-1.31 2.93-2.93V12.23a6.38 6.38 0 0 1 6.37-6.37h122.65a15.87 15.87 0 0 0-3.62 10.11v104.86c-6.17.45-11.95 2.32-17.02 5.29H69.04c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h50.59c-7.17 6.98-11.71 16.64-11.99 27.34H69.03c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h38.89c1.49 12.24 8.58 22.78 18.63 28.97H20.71c-.97 0-1.76-.79-1.76-1.76V65.33c0-1.62-1.31-2.93-2.93-2.93s-2.93 1.31-2.93 2.93v127.06c0 4.2 3.42 7.62 7.62 7.62h126.58c21.86 0 39.64-17.78 39.64-39.64 0-6.07-1.34-11.89-3.97-17.31ZM150.19 15.97c0-5.57 4.53-10.11 10.11-10.11s10.11 4.53 10.11 10.11V38.7a.2.2 0 0 1-.2.2h-20.02z",
    style: {
      fill: "url(#sla-01_svg2__o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.24 155.99a8.49 8.49 0 0 0-6.05-2.51h-.08c-2.32.02-4.48.95-6.09 2.62-3.22 3.34-3.11 8.77.24 12.13l7.38 7.38c2.15 2.15 4.94 3.44 7.83 3.61.24 0 .47.02.71.02 3.16 0 6.2-1.25 8.43-3.49L169.36 156a8.5 8.5 0 0 0 2.51-6.13 8.5 8.5 0 0 0-2.62-6.09c-3.34-3.22-8.77-3.11-12.12.24s-15.93 15.94-15.93 15.94l-3.97-3.97Zm24-7.81c1.11-1.11 2.86-1.18 3.91-.17.53.51.82 1.19.83 1.92 0 .73-.27 1.42-.79 1.93h.03l-19.75 19.76c-1.24 1.24-2.89 1.86-4.65 1.76-1.46-.09-2.9-.76-4.04-1.9l-7.38-7.38c-1.11-1.11-1.18-2.86-.17-3.91.51-.53 1.19-.82 1.92-.83.73 0 1.42.27 1.93.79l5.42 5.42c.72.72 1.67 1.11 2.68 1.11s1.97-.39 2.68-1.11z",
    style: {
      fill: "url(#sla-01_svg2__p)"
    }
  }));
};
export default SvgSla01;